import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

// A reusable page header with back button and title.
export function PageHeader({ title, subtitle, right, backTo }) {
  const navigate = useNavigate();
  const { isRTL } = useT();
  const BackIcon = isRTL ? ChevronRight : ChevronLeft;
  return (
    <div className="flex items-center gap-3 mb-5">
      <button
        data-testid="page-back"
        onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
        className="w-10 h-10 rounded-xl bg-white border border-[#E8EAF2] flex items-center justify-center text-[#161629] hover:bg-[#F7F8FE]"
      >
        <BackIcon size={20} />
      </button>
      <div className="flex-1 min-w-0">
        <h1 className="text-xl font-black text-[#161629] truncate">{title}</h1>
        {subtitle ? <p className="text-sm text-[#6B7280] truncate">{subtitle}</p> : null}
      </div>
      {right}
    </div>
  );
}
